import { forwardRef } from "react";

import footerImg from "@/assets/images/footerImg.png";
import defaultLogo from "@/assets/images/headerImg.png";

import watermarkImg from "/fav.png";

import { WasteFormat } from "@/interfaces/wastetype.interface";
import { cn } from "@/lib/utils";
import { useGetWasteFormatQuery } from "@/redux/api/wasteManageSummaryandSettings";

interface OverlayProps {
  wasteSettings?: WasteFormat;
}

const Overlay = forwardRef<HTMLDivElement, OverlayProps>((props, ref) => {
  const { data: res } = useGetWasteFormatQuery({});

  const data = props?.wasteSettings || (res as WasteFormat);

  return (
    <div
      ref={ref}
      className={cn(
        "flex flex-col min-h-[1100px] justify-between aspect-[1/1.414] min-w-[764px]",
      )}
    >
      {data?.headerActive && (
        <div className='w-full'>
          <img
            src={data?.headerImage || defaultLogo}
            alt='formatLogo'
            className={cn(
              `w-full object-fill`,
              ref === null ? "h-20" : "h-[125px]",
            )}
            style={{ opacity: data?.headerOpacity }}
          />
        </div>
      )}
      {data?.watermarkActive && (
        <div className='m-auto'>
          <img
            src={data?.watermarkImage || watermarkImg}
            alt='form watermark'
            className='w-[150px] mix-blend-multiply shadow-none border-none h-[150px] object-contain'
            style={{ opacity: data?.watermarkOpacity }}
          />
        </div>
      )}
      {data?.footerActive && (
        <div className='w-full place-self-end'>
          <img
            src={data?.footerImage || footerImg}
            alt='footer'
            className={cn(
              `w-full object-fill`,
              ref === null ? "h-20" : "h-[125px]",
            )}
            style={{ opacity: data?.footerOpacity }}
          />
        </div>
      )}
    </div>
  );
});

Overlay.displayName = "Overlay";
export default Overlay;
